import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileNotesController } from 'presentation/page/profile/coachee-profile/coachee-profile-notes/coachee-profile-notes.controller';

@Component({
	selector: 'spr-coachee-profile-notes-header',
	templateUrl: './coachee-profile-notes-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'md:flex hidden md:flex-none md:items-center md:bg-grey-alabaster md:p-3 md:space-x-3',
	},
})
export class CoacheeProfileNotesHeaderComponent {
	constructor(public controller: CoacheeProfileNotesController) {}
}
